var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.editAgency)?_c('agency-details',{attrs:{"agency":_vm.agency,"loading":_vm.loading},on:{"editCard":_vm.agencyEdit}}):_c('agency-edit',{attrs:{"agency":_vm.agency},on:{"editCard":_vm.agencyEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }